<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "favouritePropertyCard",
  data() {
    return {
      pageCur: 1,
      pageSize: 8
    };
  },
  props: {
    property: Object
  },
  methods: {
    ...mapActions("home", ["cancelCollect"]),
    ...mapMutations("book", ["setLst", "collect"]),
    ...mapMutations("reserve", {
      setReserveLst: "setLst",
      collectReserve: "collect"
    }),
    ...mapActions("book", ["getLst"]),
    removeFavourite(propertyId) {
      var that = this;
      that.cancelCollect({
        params: { propertyId: propertyId },
        callback: that.cancelCallback
      });
    },
    cancelCallback(res, id) {
      var that = this;
      if (res.data.code == 0) {
        that.collect({ data: { type: "yes", id: id } });
        that.$forceUpdate();
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        res.data.data.formatList = [];
        res.data.data.list.forEach(v => {
          if (v.housePropertyPOJO.imageUrl) {
            if (v.housePropertyPOJO.imageUrl.indexOf(",") !== -1) {
              v.housePropertyPOJO.imgLst = v.housePropertyPOJO.imageUrl.split(
                ","
              );
            } else {
              v.housePropertyPOJO.imgLst = [v.housePropertyPOJO.imageUrl];
            }
          }
          if (v.houseRoomPojosList.length > 0) {
            res.data.data.formatList.push({
              propertyId: v.housePropertyPOJO.propertyId,
              imgLst: v.housePropertyPOJO.imgLst,
              address: v.housePropertyPOJO.address,
              suburb: v.housePropertyPOJO.suburb,
              price:
                v.houseRoomPojosList[0].revisedPrice !== ""
                  ? that.$box.formatSplit(
                      v.houseRoomPojosList[0].revisedPrice,
                      true
                    )
                  : "",
              rental: that.$box.formatSplit(v.housePropertyPOJO.rental, true),
              maxRental: that.$box.formatSplit(
                v.housePropertyPOJO.maxRental,
                true
              ),
              rentalYield: v.housePropertyPOJO.rentalYield,
              commision: that.$box.formatSplit(
                parseInt(v.housePropertyPOJO.commission),
                true
              ),
              maxCommision:
                v.housePropertyPOJO.maxCommision !== ""
                  ? that.$box.formatSplit(
                      parseInt(v.housePropertyPOJO.maxCommision),
                      true
                    )
                  : "",
              bedsNumber: v.houseRoomPojosList[0].beds
                ? v.houseRoomPojosList[0].beds
                : "",
              favoritesFlag: v.favoritesFlag,
              proertyType: v.housePropertyPOJO.proertyType,
              roomId: v.houseRoomPojosList[0].roomId
                ? v.houseRoomPojosList[0].roomId
                : undefined,
              state: v.housePropertyPOJO.state,
              postcode: v.housePropertyPOJO.postcode,
              apt: v.houseRoomPojosList[0].apt
                ? v.houseRoomPojosList[0].apt
                : "",
              sellFlag: 1,
              orderId: v.ordersId && v.ordersId !== "" ? v.ordersId : null,
              operate: 1,
              clickFlag: true,
              estimatedCompletion: v.housePropertyPOJO.estimatedCompletion,
              estimatedCommenceMent: v.housePropertyPOJO.estimatedCommenceMent,
              landPrice:
                v.housePropertyPOJO.landPrice !== ""
                  ? that.$box.formatSplit(v.housePropertyPOJO.landPrice, true)
                  : "",
              buildPrice:
                v.housePropertyPOJO.buildPrice !== ""
                  ? that.$box.formatSplit(v.housePropertyPOJO.buildPrice, true)
                  : "",
              incentives: v.housePropertyPOJO.incentives,
              ordersId: v.ordersId && v.ordersId !== "" ? v.ordersId : null
            });
          }
        });
        that.setLst({ data: res.data.data });
        this.dataValues = res.data.data;
        console.log("--------------------");
        console.log(this.dataValues);
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    goPropertyDetails(query) {
      this.$router.push({
        path: "/property-details/view",
        query: { pid: query }
      });
    }
  },
  computed: {
    formattedPriceRange() {
      const { price, maxPrice } = this.property.housePropertyPOJO;

      const formatNumber = (num) => {
        return num.toLocaleString('en-AU');
      };

      if (price > 0 && maxPrice > 0) {
        return `$${formatNumber(price)} - $${formatNumber(maxPrice)}`;
      } else if (price > 0) {
        return `$${formatNumber(price)}`;
      } else if (maxPrice > 0) {
        return `$${formatNumber(maxPrice)}`;
      }
      return 'TBA';
    },
  },
  created() {
    var that = this;
    that.getLst({
      params: {
        page: that.pageCur,
        pageSize: that.pageSize
      },
      callback: that.callback
    });
  }
};
</script>

<template>
  <el-card
    :body-style="{ padding: '0px' }"
    shadow="always"
    style="border-bottom-left-radius: 20px; border-bottom-right-radius: 20px; cursor: pointer;"
  >
    <div @click.stop="goPropertyDetails(property.housePropertyPOJO.propertyId)">
      <el-row>
        <el-col :span="24" class="img-container">
          <el-image
            v-if="
              property.housePropertyPOJO.imgLst == undefined ||
                property.housePropertyPOJO.imgLst[0] == null ||
                property.housePropertyPOJO.imgLst[0] == ''
            "
            class="image"
            loading="lazy"
            src="../../assets/coming-soon.jpg"
          />
          <el-image
            v-else
            :src="property.housePropertyPOJO.imgLst[0]"
            :fit="'cover'"
            style="height: 100%; width: 100%"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="24"
          :style="{
            backgroundColor:
              property.housePropertyPOJO.companyColour || '#003333',
            padding: '5px 10px'
          }"
        >
          <el-image
            :src="property.housePropertyPOJO.companyLogoUrl"
            style="max-height: 40px; max-width: 120px"
            class="image"
          />
          <el-avatar
            :size="50"
            :src="property.housePropertyPOJO.agentImageUrl1"
            style="position: absolute; top: 25px; right: 25px; border: 2px solid #003333"
          />
        </el-col>
      </el-row>
      <el-row style="padding: 10px 10px 5px 10px">
        <el-col :span="24">
          <span class="price-range-lbl">{{ formattedPriceRange }}</span>
        </el-col>
      </el-row>
      <el-row style="padding: 5px 10px">
        <el-col :span="24">
          <span class="address-lbl omit">
            <template
              v-if="
                property.housePropertyPOJO.address &&
                  property.housePropertyPOJO.suburb
              "
              >{{ property.housePropertyPOJO.address }},
              {{ property.housePropertyPOJO.suburb }}</template
            >
            <template v-else-if="property.housePropertyPOJO.address">{{
              property.housePropertyPOJO.address
            }}</template>
            <template v-else-if="property.housePropertyPOJO.suburb">{{
              property.housePropertyPOJO.suburb
            }}</template>
            <template v-else>TBA</template>
          </span>
        </el-col>
      </el-row>
      <el-row style="padding: 5px 10px">
        <el-col :span="24">
          <span class="state-lbl">
            <template
              v-if="
                property.housePropertyPOJO.state &&
                  property.housePropertyPOJO.postcode
              "
              >{{ property.housePropertyPOJO.state }}
              {{ property.housePropertyPOJO.postcode }}</template
            >
            <template v-else-if="property.housePropertyPOJO.state">{{
              property.housePropertyPOJO.state
            }}</template>
            <template v-else-if="property.housePropertyPOJO.postcode">{{
              property.housePropertyPOJO.postcode
            }}</template>
            <template v-else>TBA</template>
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="24"
          style="display: flex; justify-content: flex-end; padding: 0 20px"
        >
          <el-button
            type="text"
            class="del-btn"
            @click.stop="removeFavourite(property.housePropertyPOJO.propertyId)"
          >
            Remove
          </el-button>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<style scoped>
.image {
  width: 100%;
  display: block;
  height: 200px;
  object-fit: fill;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.price-range-lbl {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.address-lbl {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.state-lbl {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.img-container {
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  overflow: hidden;
  position: relative;
  height: 200px;
}

.omit {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

.del-btn {
  color: #003333;
  font: 18px/125% DINosaur-a, sans-serif;
  transition: color 0.3s ease-in-out;
}

.del-btn:hover {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/favouritePropertyCard.vue